module.exports = __webpack_public_path__ + "static/img/logo.efda0d81.png";